// src/pages/NotFound/NotFound.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from './styles';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/');
  };

  useEffect(() => {
    document.title = '404 - Page Not Found | Austin Davenport';
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute('content', 'noindex, nofollow');
    return () => {
      if (robots) robots.setAttribute('content', 'index, follow');
    };
  }, []);

  return (
    <S.Container>
      <S.ScanLine />
      <S.ContentWrapper>
        <S.TimecodeBar>
          <S.TimecodeSegment>AUSTIN DAVENPORT</S.TimecodeSegment>
          <S.TimecodeSegment>|</S.TimecodeSegment>
          <S.TimecodeSegment highlight>404</S.TimecodeSegment>
        </S.TimecodeBar>

        <S.ErrorCode>404</S.ErrorCode>

        <S.StatusBadge>Page Not Found</S.StatusBadge>

        <S.ErrorTitle>This page was not found.</S.ErrorTitle>
        <S.ErrorDescription>
          The link may have moved, or the page no longer exists. Try one of these places instead.
        </S.ErrorDescription>

        <S.ButtonGroup>
          <S.PrimaryButton onClick={() => navigate('/')}>
            <i className='bx bx-home'></i>
            Back to Home
          </S.PrimaryButton>
          <S.SecondaryButton onClick={handleGoBack}>
            <i className='bx bx-arrow-back'></i>
            Go Back
          </S.SecondaryButton>
        </S.ButtonGroup>

        <S.Divider />

        <S.SuggestedLinks>
          <S.SuggestedTitle>Or jump to</S.SuggestedTitle>
          <S.SuggestedGrid>
            <S.SuggestedLink to="/portfolio">
              <i className='bx bx-book-alt'></i>
              Portfolio
            </S.SuggestedLink>
            <S.SuggestedLink to="/projects">
              <i className='bx bx-layer'></i>
              Projects
            </S.SuggestedLink>
            <S.SuggestedLink to="/blog">
              <i className='bx bx-pen'></i>
              Blog
            </S.SuggestedLink>
            <S.SuggestedLink to="/contact">
              <i className='bx bx-phone'></i>
              Contact
            </S.SuggestedLink>
          </S.SuggestedGrid>
        </S.SuggestedLinks>
      </S.ContentWrapper>
    </S.Container>
  );
};

export default NotFound;
